var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5284_222008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.5V1.5C9.5 0.673 8.827 0 8 0H4C3.173 0 2.5 0.673 2.5 1.5V4.5C2.5 6.26 3.806 7.7205 5.5 7.964V11H4C3.724 11 3.5 11.2235 3.5 11.5C3.5 11.7765 3.724 12 4 12H8C8.276 12 8.5 11.7765 8.5 11.5C8.5 11.2235 8.276 11 8 11H6.5V7.964C8.194 7.7205 9.5 6.26 9.5 4.5ZM3.5 4.5V1.5C3.5 1.224 3.7245 1 4 1H5.5345C5.5345 1 4.5505 2.407 4.535 2.4585C4.4615 2.7015 4.5075 2.969 4.6595 3.174C4.811 3.378 5.0535 3.5 5.308 3.5H6.342L5.5755 4.7365C5.43 4.9715 5.5025 5.2795 5.737 5.425C5.819 5.476 5.91 5.5 6 5.5C6.167 5.5 6.331 5.416 6.4255 5.2635L7.3665 3.745C7.53 3.4985 7.5445 3.183 7.4045 2.922C7.2645 2.6615 6.994 2.4995 6.698 2.4995H5.699L6.7595 0.9995H8.0005C8.276 0.9995 8.5005 1.2235 8.5005 1.4995V4.4995C8.5005 5.878 7.379 6.9995 6.0005 6.9995C4.622 6.9995 3.5005 5.878 3.5005 4.4995L3.5 4.5Z",
    fill: "#DC6803"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5284_222008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "66a454e24023a8f588b2eb974258ef4e.svg";
export { ForwardRef as ReactComponent };